<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import * as ls from "local-storage";

  export let _id;
  export let name;
  export let price;
  export let inventoryLevel;
  export let reorderLevel;
  export let supplierID;
  export let SKU;
  export let rowN;
  export let colour;
  export let stockType;

  let mult = (a, b) => {
    let result = Number.parseFloat(a) * Number.parseFloat(b);
    return result.toFixed(2);
  };

  onMount(() => {});

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/orders/with-item/${_id}`,
      { headers: { authorization: ls.get("jwt") } }
    );

    let usedIn = resItem?.data?.usedIn;

    console.log(usedIn);

    if (usedIn) {
      alert(
        `${name} is being used in the Orders database.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${name}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/items/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleAdd = () => {
    let qty = prompt(`Enter the quantity to add to stock. Example. 20`);
    qty = qty.replaceAll(/[^\d.-]/g, "");

    axios
      .put(
        `${$config.backendURL}/items/increment/${_id}`,
        { qty },
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        dispatch("delete");
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div
    style="min-width: 12.5rem; max-width: 12.5rem;"
    class="flex items-center"
  >
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a
      href={`/products/${_id}`}
      use:link
      class="text-base btn btn-gray-outline mr-2"
    >
      <i class="fas fa-eye" />
    </a>
    <button class="text-base btn btn-green-outline mr-2" on:click={handleAdd}>
      <i class="fas fa-plus" />
    </button>
  </div>
  {#if inventoryLevel > reorderLevel}
    <div style="min-width: 20rem; max-width: 20rem;">{name}</div>
  {:else}
    <div
      style="min-width: 20rem; max-width: 20rem;"
      class="flex items-center text-red-500"
    >
      <div
        class="text-xs px-2 py-1 flex items-center bg-red-100 mr-2 rounded-md"
      >
        <i class="fas fa-exclamation-triangle mr-1" />
        Low
      </div>
      {name}
    </div>
  {/if}
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {stockType}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    R{price}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {inventoryLevel}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {reorderLevel}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">{SKU}</div>
  <div style="min-width: 10rem; max-width: 10rem;">
    {$config.suppliers.find(({ value }) => value == supplierID).label}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">
    {colour || "Not assigned"}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">
    {rowN || "Not assigned"}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    R{mult(inventoryLevel, price)}
  </div>
</div>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
